export const zenIds = [
    {
        id: "14991662594321",
        route: "/mydashboard",
        name: "mydashboard",
        section: true
    },
    {
        id: "14991662594321",
        route: "/myteamsdashboard",
        name: "myteamsdashboard",
        section: true
    },
    {
        id: "14992620411665",
        route: "/applications",
        name: "appsMainPage",
        section: true
    },
    {
        id: "14992620411665",
        route: "/applications/AddToArchive",
        name: "AddToArchive",
        section: true
    },
    {
        id: "14991691479697",
        route: "/tasks",
        name: "myOpenTasks",
        section: true
    },
    {
        id: "14991691479697",
        route: "/tasks/teamsTasks",
        name: "teamsTasks",
        section: true
    },
    {
        id: "14992165827729",
        route: "/administration/workSchedule",
        name: "schedule",
        section: true
    },
    {
        id: "14992106703249",
        route: "/administration/users",
        name: "roles",
        section: true
    },
    {
        id: "14994731362961",
        route: "/administration/messagingAndComm",
        name: "messagingAndComm",
        section: true
    },
    {
        id: "14992158772241",
        route: "/administration/emailTemplates",
        name: "emailTemplates",
        section: true
    },
    {
        id: "14992205485201",
        route: "/administration/features",
        name: "FeaturesMainPage",
        section: true
    },
    {
        id: "14992161147409",
        route: "/administration/authentication",
        name: "Authentication",
        section: true
    },
    {
        id: "14992207886609",
        route: "/administration/systemApis",
        name: "SystemApis",
        section: true
    },
    {
        id: "14992213957265",
        route: "/administration/sslCertificates",
        name: "SSLCertificates",
        section: true
    },
    {
        id: "14992214973713",
        route: "/administration/branding",
        name: "branding",
        section: true
    },
    {
        id: "14992216162321",
        route: "/administration/processController",
        name: "processInspector",
        section: true
    },
    {
        id: "18135831766289",
        route: "/logs",
        name: "logs",
        section: true
    },
    {
        id: "15264945232401",
        route: "/dataStore/dataTables",
        name: "dataStore",
        section: true
    },
    {
        id: "15264945232401",
        route: "/dataStore/connectionsLegacy",
        name: "dataStoreLegacy",
        section: true
    },
    {
        id: "14991903314065",
        route: "/tasks/:id",
        name: "appUserTask",
        section: true
    },
    {
        id: "14991520937233",
        route: "/userProfile",
        name: "myAccount",
        section: false
    },
    {
        id: "14992640890513",
        route: "/processes",
        name: "ProcessList",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Processes",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705723562257-Processes"
        }
    },
    {
        id: "14992640890513",
        route: "/process",
        name: "process",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Processes",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705723562257-Processes"
        }
    },
    {
        id: "14992655596561",
        route: "/userInterfaces",
        name: "userInterfaces",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build User Interfaces",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705775429009-User-Interfaces"
        }
    },
    {
        id: "14993709211153",
        route: "/dataModel",
        name: "dataModel",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Data Model",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705795703313-Data-Model"
        }
    },
    {
        id: "14993756861201",
        route: "/catalogs",
        name: "catalogs",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Catalogs",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705875586065-Catalogs"
        }
    },
    {
        id: "14993759624081",
        route: "/documentTemplates",
        name: "documents",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Documents Templates",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705801276561-Document-Templates"
        }
    },
    {
        id: "14993711770129",
        route: "/integrations",
        name: "apis",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Configure Integrations",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705823745809-Integrations"
        }
    },
    {
        id: "14993711770129",
        route: "/integrations/externalApi",
        name: "consumed",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Configure Integrations",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705823745809-Integrations"
        }
    },
    {
        id: "14993711770129",
        route: "/integrations/exposedCredentials",
        name: "expose",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Configure Integrations",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705823745809-Integrations"
        }
    },
    {
        id: "14993711770129",
        route: "/integrations/systemApi",
        name: "internalApis",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Configure Integrations",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705823745809-Integrations"
        }
    },
    {
        id: "14997861864721",
        route: "/smartContractList",
        name: "smartContractList",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Configure Smart Contracts",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/14998067134737-Smart-Contracts"
        }
    },
    {
        id: "14993753849873",
        route: "/customDataViews",
        name: "perspectiveBuilder",
        section: true,
        fromBuilding: true,
        extraData: {
            name: "Build Custom Data Views",
            html_url: "https://help.aurachain.ch/hc/en-us/articles/13705876175377-Custom-Data-Views"
        }
    },
    {
        id: "14997779051921",
        route: "/dataViews",
        name: "search",
        section: true,
        fromBuilding: true
    },
    {
        id: "14993764134417",
        route: "/analytics/processLiveView",
        name: "reports",
        section: true,
        fromBuilding: true
    },
    {
        id: "14993764134417",
        route: "/analytics/processStatistics",
        name: "statistics",
        section: true,
        fromBuilding: true
    },
    {
        id: "14992895898897",
        route: "/settings/general",
        name: "highlights",
        section: true,
        fromBuilding: true
    },
    {
        id: "14992895898897",
        route: "/settings/workSchedule",
        name: "appSchedule",
        section: true,
        fromBuilding: true
    },
    {
        id: "14992895898897",
        route: "/settings/appSpecificGroups",
        name: "appSpecificGroups",
        section: true,
        fromBuilding: true
    },
    {
        id: "14992895898897",
        route: "/settings/permissions",
        name: "permissions",
        section: true,
        fromBuilding: true
    }
];
